module.exports = require("react-dev-utils/ForkTsCheckerWebpackPlugin");